import isString from "lodash/isString";

export const snakeToCamel = string => {
  return string.replace(/(\_[a-z])/g, item => item.toUpperCase().replace('_', ''));
};

export const camelToSnake = string => {
  return string.replace(/([A-Z])/g, item => '_' + item.toLowerCase());
};

export const trimAndRemoveSpaces = value => {
  if (isString(value)) {
    return value.trim().replace(/[ \t]{2,}/g, ' ');
  }
  return value;
};